import {
    isNaN,
    isNumber,
    isString,
    isDate,
    addZero
} from "./main";

export function printFullNamedDate(date) {
    date = parseDate(date).date; // also fix time zone (iso without Z)

    const weekDayName = window.langDictionary.getDayName(date.getDay());
    const monthName = window.langDictionary.getMonthName(date.getMonth());

    const HH = addZero(date.getHours(), 2);
    const MM = addZero(date.getMinutes(), 2);

    const seconds = date.getSeconds();
    const MS = addZero(date.getMilliseconds(), 3);
    const secondsName = window.langDictionary.get("seconds");
    const SS_MS = date.getMilliseconds() == 0
        ? `${seconds} ${secondsName}`
        : `${seconds}.${MS} ${secondsName}`;

    const timeZone = "GMT" + date.toString().split("GMT").slice(1).join("GMT");
    return `${weekDayName} ${date.getDate()} ${monthName} ${date.getFullYear()}, ${HH}:${MM} (${SS_MS}) ${timeZone}`;
}

export function getLastDayOfMonth(year, month) {
    let date = new Date(+year, +month + 1, 0);
    return date.getDate();
}

export function minutesToTimeFormat(minutes, roundTo) {
    roundTo = roundTo || 1;
    minutes = Math.max(0, minutes);

    let hours = Math.floor(minutes / 60);

    minutes = minutes % 60;
    // округляем до 0 15 30 45 60 (если roundTo = 15)
    minutes = roundTo * Math.round(minutes * ( 1 / roundTo ));
    if ( minutes > 59 ) {
        hours++;
        minutes = 0;
    }

    hours = Math.min(hours, 23);

    if ( hours < 10 ) {
        hours = "0" + hours;
    }

    if ( minutes < 10 ) {
        minutes = "0" + minutes;
    }

    return hours + ":" + minutes;
}

export function timeFormatToMinutes(time) {
    return 60 * time.split(":")[0] + 1 * time.split(":")[1];
}


// 1440 => "24:00"
export function minutes2hoursMinutes(value) {
    if ( value == null ) {
        return "";
    }

    // cast to number
    value = +value;

    let hours = Math.floor(value / 60);
    let minutes = value % 60;

    // cast to text
    if ( hours < 10 ) {
        hours = "0" + hours;
    } else {
        hours = hours + "";
    }

    // cast to text
    if ( minutes < 10 ) {
        minutes = "0" + minutes;
    } else {
        minutes = minutes + "";
    }

    return hours + ":" + minutes;
}

/**
 * Автоматическое заполнение строки с датой и временем.
 * @param {*} dateStr
 */
export function autoFillDateString(dateStr) {
    if (
        // Отсеиваем полностью заполненные даты и полностью пустые.
        /^([^\d]*|[^_]*)$/m.test(dateStr)
        // Отсеиваем строки не соответсвующие шаблону даты.
        || !(/[\d_]{2}.[\d_]{2}.[\d_]{4}( [\d_]{2}:[\d_]{2})?/.test(dateStr))
    ) return dateStr;

    let [day, month, year, hours, minutes] = dateStr.match(/[\d_]+/gm) || [];

    const currentDate = new Date();

    if ( day === "0_" ) {
        day = "01";
        month = "01";
        year = currentDate.getFullYear();
        if ( hours && minutes ) {
            hours = "00";
            minutes = "00";
        }
    } else {
        if ( day === "__" ) {
            day = ("0" + currentDate.getDate()).slice(-2);
        }

        if ( month === "__" ) {
            month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
        }

        if ( year === "____" ) {
            year = currentDate.getFullYear();
        }

        if ( /\d\d__/.test(year) ) {
            year = currentDate.getFullYear().toString().slice(0, 2)
                + year.slice(0, 2);
        }

        if ( hours === "__" ) {
            hours = "00";
        }

        if ( minutes === "__" ) {
            minutes = "00";
        }
    }

    const date = `${day}.${month}.${year}`;
    const time = hours && minutes ? ` ${hours}:${minutes}` : "";

    return date + time;
}

// на ВХОДЕ может быть:
// unixTimestamp,
// timestamp,
// объект Date,
// то что может распарсить parseDate (dd.mm.yyyy hh:mm:ss и подобное),
// то что может распарсить Date.parse
// на ВЫХОДЕ
// ISO или
// NaN - если не удалось распарсить время
export function clientTime2serverTime(clientTime) {
    let timestamp;

    timestamp = +parseDate(clientTime + "").date;
    if ( isNaN(timestamp) ) {
        timestamp = Date.parse(clientTime);
    }

    return unixTimestamp2serverTime(timestamp);
}

// на ВХОДЕ может быть:
// unixTimestamp,
// timestamp,
// объект Date,
// то что может распарсить parseDate (dd.mm.yyyy hh:mm:ss и подобное),
// то что может распарсить Date.parse
// на ВЫХОДЕ
// unixTimestamp или
// NaN - если не удалось распарсить время
export function clientTime2unixTimestamp(clientTime) {
    let timestamp;

    timestamp = +parseDate(clientTime + "").date;
    if ( isNaN(timestamp) ) {
        timestamp = Date.parse(clientTime);
    }

    return timestamp;
}

/**
 * ```js
 * // Строка
 * "01.10.1993"
 * "01.10.1993 08:00"
 * "01.10.1993 08:00"
 * "1993-10-01T05:00:00.821Z"
 *
 * // Число (unix timestamp)
 * 1580369945112
 *
 * // Объект Date
 * new Dat()
 *
 * ```
 * @param {string|number|Date} str
 * @returns {{format: string, date: Date}}
 */
export function parseDate(str) {
    let defFormat = "d.m.Y H:i";

    let date;
    let format;
    let year;
    let month;
    let day;
    let hours;
    let minutes;
    let seconds;

    if ( isNumber(+str) ) {
        date = new Date(+str);
        format = defFormat;
    }
    else if ( isDate(str) ) {
        date = str;
        format = defFormat;
    }
    else if ( isString(str) ) {
        str = str.trim();

        // сначало проверяем на формат ISO
        // 2015-08-31T21:00:00.000Z
        if ( /^\d\d\d\d-\d\d-\d\dT\d\d:\d\d:\d+/.test(str) ) {
            // @see userAction, дата плохо парсится хз почему, помогает только этот if
            if ( !/Z$/i.test(str) ) {
                str += "Z";
            }

            return {
                format: "YYYY-MM-DDTHH:mm:ss.sssZ",
                date: new Date(Date.parse(str))
            };
        }
        // дописываем неполные даты

        // указан только год
        if ( /^\d\d\d\d$/.test(str) ) {
            str = "01." + str;
        }

        // указан месяц без нуля и год
        if ( /^\d.\d\d\d\d$/.test(str) ) {
            str = "01.0" + str;
        }
        // указан месяц с нулем и год
        if ( /^\d\d.\d\d\d\d$/.test(str) ) {
            str = "01." + str;
        }

        // день указан без нуля, месяц с нулем или без, год
        if ( /^\d.(\d\d|\d).\d\d\d\d$/.test(str) ) {
            str = "0" + str;
        }
        // день, месяц без нуля, год
        if ( /^\d\d.\d.\d\d\d\d$/.test(str) ) {
            str = str.slice(0, 3) + "0" + str.slice(3);
        }

        // разделители могут абсолютно любые
        // day.month.year hours:minutes:seconds:ms
        // 26.06.2015 12:03:48:123
        // year.month.day hours:minutes:seconds:ms
        // 2015.06.26 12:03:48:123
        if ( /^(\d\d.\d\d.\d\d\d\d|\d\d\d\d.\d\d.\d\d)(.\d\d.\d\d(.\d\d(.\d\d\d)?)?)?/.test(str) ) {

            if ( /^\d\d\d\d/.test(str) ) {
                day = str.slice(8, 10);
                month = str.slice(5, 7) - 1;
                year = str.slice(0, 4);
                format = [
                    "Y",
                    str.slice(4, 5),
                    "m",
                    str.slice(7, 8),
                    "d"
                ].join("");
            } else {
                day = str.slice(0, 2);
                month = str.slice(3, 5) - 1;
                year = str.slice(6, 10);
                format = [
                    "d",
                    str.slice(2, 3),
                    "m",
                    str.slice(5, 6),
                    "Y"
                ].join("");
            }

            if ( str.length > 10 ) {
                hours = str.slice(11, 13);
                minutes = str.slice(14, 16);

                format += [
                    str.slice(10, 11),
                    "H",
                    str.slice(13, 14),
                    "i"
                ].join("");

                if ( str.length > 16 ) {
                    seconds = str.slice(17, 19);
                    format += [
                        str.slice(16, 17),
                        "s"
                    ].join("");

                    /*
						if ( str.length > 19 ) {
							ms = str.slice(20, 23);
								format += [
								str.slice(19, 20),
								"xxx"
							].join('');
							date = new Date(year, month, day, hours, minutes, seconds, ms);
						} else {
						*/
                    date = new Date(year, month, day, hours, minutes, seconds);
                    //}
                } else {
                    date = new Date(year, month, day, hours, minutes);
                }
            } else {
                date = new Date(year, month, day);
            }
        } else {
            date = new Date(str);
            format = defFormat;
            // unknown date
        }
    } else {
        date = new Date();
        format = defFormat;
    }

    return { date, format };
}

export function unixTimestamp2serverTime(unixTimestamp) {
    if ( isNaN(+unixTimestamp) ) {
        return +unixTimestamp;
    }

    return new Date(unixTimestamp).toISOString(); // 2016-05-19 03:00 UTC+3 превращается в 2016-05-19 00:00 UTC
}

export function serverTime2timestamp(isoString) {
    return Date.parse(isoString);
}

// любая дата в dd.mm.yy
export function serverTime2clientUserDate(date) {
    date = parseDate(date).date;
    date = timestamp2userdate(date);
    return date.split(" ")[0];
}

export function timestamp2userdate(timestamp) {
    let date = new Date(timestamp);
    let month = date.getMonth() + 1;

    // дата некорректна
    if ( month + "" == "NaN" ) {
        return "";
    }

    let hours = date.getHours();
    let minutes = date.getMinutes();

    if ( month < 10 ) {
        month = "0" + month;
    }
    if ( hours < 10 ) {
        hours = "0" + hours;
    }
    if ( minutes < 10 ) {
        minutes = "0" + minutes;
    }

    let day = date.getDate();
    if ( day < 10 ) {
        day = "0" + day;
    }

    return day + "." + month + "." + date.getFullYear() + " " + hours + ":" + minutes;
}

export function printDateWithMilliseconds(date) {
    date = parseDate(date).date;

    const day = addZero(date.getDate());
    const month = addZero(date.getMonth() + 1);
    const year = date.getFullYear();

    const hours = addZero(date.getHours());
    const minutes = addZero(date.getMinutes());
    const seconds = addZero(date.getSeconds());
    const ms = date.getMilliseconds();

    const dateString = `${day}.${month}.${year}`;
    const timeString = `${hours}:${minutes}:${seconds}.${ms}`;
    return `${dateString} ${timeString}`;
}

// если сегодня, то время: 11:07
// если на неделе, то день недели: Вт
// если раньше, то дата:  10.08.14
export function printTimeOrDate(date) {
    if ( date === null || date === undefined ) {
        return "";
    }

    date = parseDate(date).date;
    let now = new Date();
    let morning = new Date(+now);
    let minutes;
    let day;
    let month;

    morning.setHours(0);
    morning.setMinutes(0);

    // сегодня
    if ( date > morning ) {
        minutes = date.getMinutes();
        if ( minutes < 10 ) {
            minutes = "0" + minutes;
        }
        return date.getHours() + ":" + minutes;
    }

    // вчера
    if ( date > morning - 24 * 60 * 60 * 1000 ) {
        return window.langDictionary.get("yesterday");
    }

    // в России неделя начинается с понедельника
    day = date.getDay();
    if ( day === 0 ) {
        day = 7;
    }
    day--;

    // начало недели
    if ( date > morning - day * 24 * 60 * 60 * 1000 ) {
        return [
            window.langDictionary.get("week_day_m"),
            window.langDictionary.get("week_day_t"),
            window.langDictionary.get("week_day_w"),
            window.langDictionary.get("week_day_th"),
            window.langDictionary.get("week_day_f"),
            window.langDictionary.get("week_day_s"),
            window.langDictionary.get("week_day_sn")
        ][day];
    }

    // когда-то...
    month = date.getMonth() + 1;

    if ( month < 10 ) {
        month = "0" + month;
    }

    let dateNumb = date.getDate();
    if ( dateNumb < 10 ) {
        dateNumb = "0" + dateNumb;
    }

    return dateNumb + "." + month + "." + (date.getFullYear() + "").slice(2);
}

// если сегодня, то время: 11:07
// если на неделе, то день недели: Вт, 11:07
// если раньше, то дата:  10.08.14, 11:07
export function printTimeOrDateWithTime(date) {
    if ( date === null || date === undefined ) {
        return "";
    }

    date = parseDate(date).date;
    let now = new Date();
    let morning = new Date(+now);
    let minutes = date.getMinutes();
    let day;
    let month;
    let timePart;

    if ( minutes < 10 ) {
        minutes = "0" + minutes;
    }
    timePart = date.getHours() + ":" + minutes;

    morning.setHours(0);
    morning.setMinutes(0);

    // сегодня
    if ( date > morning ) {
        return timePart;
    }

    // вчера
    if ( date > morning - 24 * 60 * 60 * 1000 ) {
        return window.langDictionary.get("yesterday") + ", " + timePart;
    }

    // в России неделя начинается с понедельника
    day = date.getDay();
    if ( day === 0 ) {
        day = 7;
    }
    day--;

    // начало недели
    if ( date > morning - day * 24 * 60 * 60 * 1000 ) {
        return [
            window.langDictionary.get("week_day_m"),
            window.langDictionary.get("week_day_t"),
            window.langDictionary.get("week_day_w"),
            window.langDictionary.get("week_day_th"),
            window.langDictionary.get("week_day_f"),
            window.langDictionary.get("week_day_s"),
            window.langDictionary.get("week_day_sn")
        ][day] + ", " + timePart;
    }

    // когда-то...
    month = date.getMonth() + 1;

    if ( month < 10 ) {
        month = "0" + month;
    }

    let dateNumb = date.getDate();
    if ( dateNumb < 10 ) {
        dateNumb = "0" + dateNumb;
    }

    return dateNumb + "." + month + "." + (date.getFullYear() + "").slice(2) + ", " + timePart;
}

export function minute2text(minutes) {
    const dayUnit = window.langDictionary.get("timelength_d");
    const hourUnit = window.langDictionary.get("timelength_h");
    const minuteUnit = window.langDictionary.get("timelength_m");

    minutes = +minutes || 0;
    if ( minutes === 0 ) {
        return `0${ dayUnit }`;
    }

    const hour = 60;
    const day = 24 * hour;

    const minus = minutes < 0 ? "-" : "";
    let positiveMinutes = Math.abs(minutes);

    const days = Math.floor(positiveMinutes / day);
    positiveMinutes = positiveMinutes - days * day;

    const hours = Math.floor(positiveMinutes / hour);
    positiveMinutes = positiveMinutes - hours * hour;

    const result = [];

    if ( days ) {
        result.push(`${ days }${ dayUnit }`);
    }

    if ( hours ) {
        result.push(`${ hours }${ hourUnit }`);
    }

    if ( positiveMinutes ) {
        result.push(`${ positiveMinutes }${ minuteUnit }`);
    }

    return `${ minus }${ result.join(" ") }`;
}

export function text2minute(text) {
    if ( typeof text !== "string" ) {
        return 0;
    }

    const dayUnit = window.langDictionary.get("timelength_d");
    const hourUnit = window.langDictionary.get("timelength_h");
    const minuteUnit = window.langDictionary.get("timelength_m");

    const hour = 60;
    const day = 24 * hour;

    const hasMinus = text.charAt(0) === "-";
    const textWithoutMinus = hasMinus ? text.slice(1) : text;

    let result = 0;

    for (const textPart of textWithoutMinus.split(" ")) {
        const days = extractNumberFromMinutesTextPart(textPart, dayUnit);
        const hours = extractNumberFromMinutesTextPart(textPart, hourUnit);
        const minutes = extractNumberFromMinutesTextPart(textPart, minuteUnit);

        result += days * day + hours * hour + minutes;
    }

    return result * (hasMinus ? -1 : 1);
}

function extractNumberFromMinutesTextPart(textPart, timeUnit) {
    if ( typeof textPart !== "string" || typeof timeUnit !== "string" ) {
        return 0;
    }

    const pattern = `^(\\d+)${timeUnit}$`;
    const [, extractedNumber] = textPart.match(pattern) || [];

    return +extractedNumber || 0;
}

export function todayStart() {
    let date = new Date();
    return +new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function todayEnd() {
    let date = new Date();
    return +new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
}

export function tomorrowStart() {
    let date = new Date();
    return +new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1 );
}

export function tomorrowEnd() {
    let date = new Date();
    return +new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, 23, 59, 59, 999);
}

export function isOnlineUser(timestamp) {
    return parseDate(timestamp).date > Date.now() - 5 * 60 * 1000;
}

export function startOfDay(date = new Date()) {
    const startOfDay = new Date(+parseDate(date).date); // parse and clone
    startOfDay.setHours(0);
    startOfDay.setMinutes(0);
    startOfDay.setSeconds(0);

    return startOfDay;
}

export function endOfDay(date = new Date()) {
    const endOfDay = new Date(+parseDate(date).date); // parse and clone
    endOfDay.setHours(23);
    endOfDay.setMinutes(59);
    endOfDay.setSeconds(59);

    return endOfDay;
}